module.exports = __webpack_public_path__ + "img/id2.56a7d4b4.png";